/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_col_utf8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UTF-8 bytes`)
};

const es_ci_col_utf8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bytes UTF-8`)
};

const de_ci_col_utf8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UTF-8-Bytes`)
};

const nl_ci_col_utf8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UTF-8 bytes`)
};

const fr_ci_col_utf8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Octets UTF-8`)
};

const it_ci_col_utf8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byte UTF-8`)
};

const pt_br2_ci_col_utf8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bytes UTF-8`)
};

const pt_ci_col_utf8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bytes UTF-8`)
};

const ja_ci_col_utf8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「UTF-8 バイト」`)
};

const zh_ci_col_utf8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UTF-8 字节`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_col_utf8 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_col_utf8(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_col_utf8", locale)
	if (locale === "en") return en_ci_col_utf8(inputs)
	if (locale === "es") return es_ci_col_utf8(inputs)
	if (locale === "de") return de_ci_col_utf8(inputs)
	if (locale === "nl") return nl_ci_col_utf8(inputs)
	if (locale === "fr") return fr_ci_col_utf8(inputs)
	if (locale === "it") return it_ci_col_utf8(inputs)
	if (locale === "pt-BR") return pt_br2_ci_col_utf8(inputs)
	if (locale === "pt") return pt_ci_col_utf8(inputs)
	if (locale === "ja") return ja_ci_col_utf8(inputs)
	return zh_ci_col_utf8(inputs)
};